import { useActiveMember } from 'hooks';
import _ from 'lodash';
import { DateTime } from 'luxon';
import IMemberOvertimePeriod from 'types/MemberOvertimePeriod';
import { dateTimeFromUtcISO } from 'utils/dateUtils';

export default function useMemberOvertimePeriods() {
  const authMember = useActiveMember();
  const today = DateTime.utc().startOf('day');
  const currentOrgOvertimePeriod = getCurrentOrgOvertimePeriod();

  function getCurrentOrgOvertimePeriod() {
    const orgOvertimePeriods = authMember.organization!.organizationOvertimePeriods;
    const sorted = _.sortBy(orgOvertimePeriods, [(o) => dateTimeFromUtcISO(o.startTime).toSeconds()]);
    const active = sorted.filter((ot) => {
      return ot.deletedOn === null && dateTimeFromUtcISO(ot.startTime).startOf('day') <= today;
    });
    return active[active.length - 1];
  }

  function getCurrentMemberOvertimePeriod(overtimePeriodArray: IMemberOvertimePeriod[]) {
    const sorted = _.sortBy(overtimePeriodArray, [(ot) => dateTimeFromUtcISO(ot.changeDate).toSeconds()]);
    const active = sorted.filter((ot) => {
      const changeDate = dateTimeFromUtcISO(ot.changeDate).startOf('day');
      return changeDate <= today;
    });
    return active[active.length - 1];
  }

  return { currentOrgOvertimePeriod, getCurrentMemberOvertimePeriod };
}
